(function(Drupal, drupalSettings) {

  "use strict";
  Drupal.behaviors.treston_header_modals = {
  	attach: function(context, settings) {
      // Modals for ebook links
      context.querySelectorAll('.node--view-mode-header .field--name-field-ebook a').forEach( function(link) {
        link.addEventListener('click', function(e) {
          var myModal = new jBox('Modal', {
            closeButton: 'box',
            width: '90%',
            maxWidth: '980px',
            height: '90%',
            content: '<iframe src="'+e.target.href+'?popup=true" style="width:100%; height: 99%;"></iframe>',
            closeOnClick: 'body',
          });
          // open modal
          myModal.open();
          e.preventDefault();
        });
      });
    }
  }

})(Drupal, drupalSettings);
